import styled from "styled-components";

export const Styles = styled.div`

  .btnHideForm {
    position: absolute;
    z-index: 99;
    background: #ea0c0c;
    top: 0;
    right: 0;
    width: 25px !important;
    height: 24px;
    display: block;
    padding: 0;
    min-width: 20px;
    border-radius: 50%;
    color: #fff !important;
    font-size: 11px;
    border: 1px solid #fff;
}
.MuiDialogContent-root button.MuiButton-root {
    position: absolute;
    top: 7px;
    right: 26px;
    background: #e61b1b;
    width: 30px !important;
    height: 20px;
    max-width: 20px;
    min-width: 20px;
    border-radius: 50%;
    color: #fff;
}
`;
